import { HeroBannerInfoProps } from '@/widgets/HeroBannerInfo'

import { FILES_URL } from '@/shared/lib/utils/constants/const'

// Временный костыль от Димы, нужно будет переписать
const linkToService = `/service/`

export const categories = [
	{
		NAME: `iPhone`,
		LINK: `/catalog/apple_iphone/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/104.jpg`
	},
	{
		NAME: `Mac`,
		LINK: `/catalog/apple_mac/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/80.jpg`
	},
	{
		NAME: `iPad`,
		LINK: `/catalog/apple_ipad/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/87.jpg`
	},
	{
		NAME: `Watch`,
		LINK: `/catalog/apple_watch/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/HeadCategoriesImages/125.jpg`
	},
	{
		NAME: `Airpods`,
		LINK: `/catalog/naushniki/filter/airpods/`,
		PICTURE: `https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/mock-images/airPods.jpg`
	}
]

export const faqItemsUr = [
	{
		question: `Для чего нужна страховка?`,
		answer: `Полис страхования экономит средства компании при повреждении, краже устройства и других рисков в зависимости от полиса. При наступлении страхового случая вы можете получить отремонтированное или новое устройство бесплатно.`
	},
	{
		question: `Как действует страховка?`,
		answer: `При наступлении страхового случая вы обращаетесь в наш сервисный центр iPort. После диагностики и согласования страховой, получаете своё отремонтированное или новое устройство.`
	},
	{
		question: `Чем отличается гарантия от страховки?`,
		answer: `Страховка покрывает те случаи, которые не покрывает стандартная гарантия от производителя: механические повреждения, кражи, залития и другие случайные риски из-за внешнего воздействия.`
	},
	{
		question: `Сколько действует страховка?`,
		answer: `Страховой полис действует 1 год.`
	},
	{
		question: `Какие есть способы оплаты?`,
		answer: `Для юридических лиц есть безналичная оплата (выставление счёта), оплата корпоративной картой в магазине и оплата наличными до 100 000 ₽ в магазине.`
	}
]

export const pdfListUr = [
	{
		title: `Памятка по страхованию мобильных устройств ВСК`,
		link: `${FILES_URL}/files/pdf/insuranceNoteVSK.pdf`
	},
	{
		title: `Правила ВСК`,
		link: `${FILES_URL}/files/pdf/insuranceRulesVSK.pdf`
	},
	{
		title: `Правила страхования имущественных рисков Альфастрахование`,
		link: `${FILES_URL}/files/pdf/insurance/pravila_strahovaniya_imushestvennyh_riskov.pdf`
	}
]
export const heroBannerInfoData: HeroBannerInfoProps = {
	title: 'Страхование устройств \n' + 'для бизнеса',
	additional: [
		{
			title: 'Качественно',
			text: 'Обслуживание в нашем сервисном центре'
		},
		{
			title: 'Легко',
			text: 'Быстрое оформление онлайн, в наших \n' + 'магазинах и у корпоративного менеджера'
		},
		{
			title: 'Надёжно',
			text: 'Большой выбор программ страхования с широким перечнем рисков.'
		}
	],
	text: 'Заботимся о вашем спокойствии, поэтому вместе с ВСК запустили программу страхования устройств для бизнеса. Она покрывает случаи механического повреждения кражи и прочих рисков.',
	buttonLabel: 'Узнать стоимость',
	image: {
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/B2bInsurance/HeroInfoBanner.png',
		height: 295,
		width: 534,
		alt: ''
	},
	links: {
		business: {
			link: '/b2b/insurance/',
			text: 'Для бизнеса',
			isCurrent: true
		},
		regular: {
			link: '/services/insurance/',
			text: 'Частным лицам',
			isCurrent: false
		}
	}
}
export const stepsItemsUr = {
	title: 'Как это работает',
	items: [
		{
			description: `Выберите подходящую программу
у нас на сайте, у корпоративного
менеджера или в магазине`
		},
		{
			description: `При наступлении страхового случая обратитесь в любой <a  href="${linkToService}" title="К сервисным центрам" target="_blank"> сервисный центр iPort</a>.`
		},
		{
			description: `Получите отремонтированное или новое устройство в кратчайшие сроки.`
		}
	]
}
